import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import userSession from "./hooks/userSession";
import "./App.css";

function App() {
  const { user, login, logout } = userSession();

  return (
    <BrowserRouter>
      <Routes
        user={user}
        onLogin={login}
        onLogout={logout}
      />
    </BrowserRouter>
  );
}

export default App;
